import React from 'react';
import '../css/AssignOkasboxes.css';
// import Icon from 'react-icons-kit';
// import { iosPlusEmpty } from 'react-icons-kit/ionicons';
// import Modal from 'react-modal';
import IconButton from '@mui/material/IconButton';
import AddIcon from '@mui/icons-material/Add';
import _ from 'lodash';
// import Cookies from 'js-cookie';
import AssignOkasBoxModal from './AssignOkasBoxModal';
// import OkasAssignDistributors from './OkasAssignDistributors';
import Sorting from './Sorting';
import SearchBar from './SearchBar';
import CheckboxMaterialUI from './CheckboxMaterialUI';
import CheckboxMaterialUIWhite from './CheckboxMaterialUIWhite';
import * as ActionTypes from '../actions/types';
import { connect } from 'react-redux';
import Loader from './Loader';
// import createHistory from 'history/createBrowserHistory';
import SnackBar from './SnackBar';



//Assign okas boxes page okas of okas box ai page
class AssignOkasboxes extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      modalIsOpenAssignOB: false,
      obData: [],
      actualData: [],
      searchValue: '',
      assigningBoxes: [],
      addAnotherSuccess: '',
      loader: true,
      snackbarActive: false,
      snackbarMessage: '',
      sortingStatus: {
        sortingName: '',
        defaultDown: true
      },

    };
    this.openModal = this.openModal.bind(this);
    this.afterOpenModal = this.afterOpenModal.bind(this);
    this.closeModal = this.closeModal.bind(this);
    this.closeModalDelete = this.closeModalDelete.bind(this);
  }

  openModal() {
    this.setState({
      modalIsOpenAssignOB: false,


    }, () => {
      this.setState({
        modalIsOpenAssignOB: true,

      })
    })
  }

  afterOpenModal() {
    // references are now sync'd and can be accessed.
    // this.subtitle.style.color = '#f00';
  }

  closeModal() {
    this.setState({ modalIsOpenAssignOB: false });

  }

  closeModalDelete() {
    this.setState({
      modalIsOpenDelete: false
    });
  }


  ActivateAssignOBModel = (e) => {
    if (this.state.modalIsOpenAssignOB) {
      return <AssignOkasBoxModal activeModal={true} assigningBoxes={this.state.assigningBoxes} successMessage={this.handleSuccess.bind(this)} />
    } else {
      return null
    }
  }

  handleSuccess = (e) => {
    if (e === 'addAnother') {
      let addAnotherSuccess = (
        <div className="row my-1">
          <div class="col-12 my-2 alert alert-success fade show" role="alert">
            {/* Successfully assigned OKAS Box(es) to System Integrator. */}
            {this.state.assigningBoxes > 1 ?
              "Successfully assigned OKAS Box to Distributor." :
              "Successfully assigned OKAS Boxes to Distributor."
            }
            <button type="button" class="close" data-dismiss="alert" aria-label="Close">
            </button>
          </div>
        </div>
      );
      this.setState({ addAnotherSuccess }, () => {
        setTimeout(() => {
          this.setState({
            addAnotherSuccess: ''
          })
        }, 3500)
      })
    }
    this.setState({
      modalIsOpenAssignOB: false,
      obData: [],
      actualData: [],
      searchValue: '',
      assigningBoxes: [],
    }, () => this.fetchBoxes())
  }

  componentDidMount() {
    this.fetchBoxes();
    this.resetSearchBar()
  }

  fetchBoxes = () => {
    this.setState({
      loader: true
    })
    var tokenStored = localStorage.getItem('token');
    tokenStored = `Token ${tokenStored}`;
    var headers = {
      'Content-Type': 'application/json',
      "Access-Control-Allow-Origin": "*",
      'X-CSRFToken': localStorage.getItem('csrftoken'),
      'Authorization': tokenStored
    }
    fetch('/cloud/okasBoxApi/', {
      method: "GET",
      headers: headers,
    })
      .then(response => {
        if (response.status === 403) {
          localStorage.removeItem('token');
          localStorage.removeItem('csrftoken');
          localStorage.removeItem('auth');
          // const history = createHistory({ forceRefresh: true })
          window.location.href = '/session-timeout'
        } else {
          return response.json()
        }
      })
      .then(data => {
        this.setState({
          obData: data,
          actualData: data,
          loader: false
        })
      })
      .catch((err) => {
        console.log(err)

      })
  }



  restoreData = (data) => {
    this.setState({
      obData: data
    })
  }


  sortingFunc = (type, searchValue) => {
    if (type !== 'search') {
      if (this.state.sortingStatus.sortingName === type) {
        this.setState({
          sortingStatus: {
            sortingName: type,
            defaultDown: !this.state.sortingStatus.defaultDown
          },
        }, () => {
          if (this.state.sortingStatus.sortingName === type && this.state.sortingStatus.defaultDown) {
            Sorting(this.restoreData, type, this.state.obData.sort());
            // Sorting(this.restoreData, type, this.state.actualData);
          } else if (this.state.sortingStatus.sortingName === type && !this.state.sortingStatus.defaultDown) {
            Sorting(this.restoreData, 'reverse', this.state.obData.sort());
          }
        })
      } else {
        this.setState({
          sortingStatus: {
            sortingName: type,
            defaultDown: true
          },
        }, () => {
          if (this.state.sortingStatus.sortingName === type && this.state.sortingStatus.defaultDown) {
            Sorting(this.restoreData, type, this.state.obData.sort());
            // Sorting(this.restoreData, type, this.state.actualData);
          } else if (this.state.sortingStatus.sortingName === type && !this.state.sortingStatus.defaultDown) {
            Sorting(this.restoreData, 'reverse', this.state.obData.sort());
          }
        })
      }
    } else if (type === 'search') {
      type = 'search';
      Sorting(this.restoreData, type, this.state.actualData, searchValue);
    } else {
      type = 'reverse';
      Sorting(this.restoreData, type, this.state.actualData);
    }
  }


  fetchIconType = (e) => {
    if (e === this.state.sortingStatus.sortingName && this.state.sortingStatus.defaultDown) {
      return 'fas fa-chevron-down pointer ml-2 float-right'
    } else if (e === this.state.sortingStatus.sortingName && !this.state.sortingStatus.defaultDown) {
      return 'fas fa-chevron-up pointer ml-2 float-right'
    } else {
      return 'fas fa-chevron-down pointer ml-2 float-right icon-inactive'
    }
  }


  assignBoxCheckHandler = (okasBoxId, e) => {
    let assigningBoxes = this.state.assigningBoxes;
    if (e && okasBoxId !== 'all') {
      assigningBoxes.push(okasBoxId);
    } else if (e && okasBoxId === 'all') {
      assigningBoxes = [];
      this.state.obData.forEach((firstElement) => {
        if (firstElement.okasBox_status === "unassigned") {
          assigningBoxes.push(firstElement.okasBox_id)
        }
      })
    } else if (!e && okasBoxId === 'all') {
      assigningBoxes = [];
    } else {
      _.pull(assigningBoxes, okasBoxId);
    }
    this.setState({ assigningBoxes })
  }

  checkStatusForAll = (okasBoxId) => {
    if (okasBoxId === 'all') {
      let allChecked = true;
      this.state.obData.forEach((firstElement) => {
        if (firstElement.okasBox_status === 'unassigned' && (_.indexOf(this.state.assigningBoxes, firstElement.okasBox_id) === -1)) {
          allChecked = false;
        }
      })
      return allChecked;
    }
  }


  obDatatable = () => {
    if (this.state.obData !== null) {
      let someData = this.state.obData.map((obElement, index) => {
        if (obElement.okasBox_status === 'unassigned') {
          return <tr key={index} className="some-hover">
            <th scope="col" style={{ width: '5%' }} >
              <CheckboxMaterialUI
                changeHandler={this.assignBoxCheckHandler.bind(this, obElement.okasBox_id)}
                checkedStatus={_.indexOf(this.state.assigningBoxes, obElement.okasBox_id) !== -1}
              />
            </th>
            <td scope="col" style={{ fontSize:'12px', width: '15%', verticalAlign: 'middle', }}> {obElement.okasBox_type === 'Master Controller' ? 'Master Studio' :
              obElement.okasBox_type === "VOD Box" ? "Media Studio" :
                obElement.okasBox_type === "UVOD Box" ? "Ultra Media Studio" :
                  obElement.okasBox_type === "Audio Box" ? "Music Studio" : obElement.okasBox_type}</td>
            <td scope="col" style={{ width: '20%', verticalAlign: 'middle', fontSize:'12px' }}>{obElement.okasBox_serialNo}</td>
            <td scope="col" style={{ width: '15%', verticalAlign: 'middle', fontSize:'12px' }}>{obElement.okasBox_version}</td>
          </tr>
        }
      })
      return someData;
    } else {
      return null
    }
  }

  overlayShadowUnderModal = () => {
    if (this.state.modalIsOpenAssignOB) {
      return (
        <div style={{ position: 'absolute', height: `${window.innerHeight - 60}px`, width: `${window.innerWidth - 260}px`, backgroundColor: 'rgba(0,0,0,0.75)', zIndex: '0', display: '' }}></div>
      )
    } else {
      return null
    }
  }

  resetSearchBar = () => {
    this.props.searchBarActivate(false)
  }



  render() {
    return (
      <React.Fragment>
        {this.state.loader ? <Loader /> : null}
        <SnackBar open={this.state.snackbarActive} handleSnackbarClose={() => {
          this.setState({
            snackbarActive: false
          })
        }} message={this.state.snackbarMessage} />
        {this.overlayShadowUnderModal()}
        <div style={{ paddingLeft: '90px', paddingTop: '40px', paddingRight: '90px', height: `${window.innerHeight - 120}px` }}>
          {!this.props.redux.auth.searchBarShow ? <div style={{ marginBottom: '20px' }}>
            <span style={{ color: '#888888', fontSize: '30px', }}>ASSIGN OKAS BOXES</span>
            <span style={{ float: 'right' }}>
              {!this.props.redux.auth.searchBarShow ? <div className="row" style={{ margin: '0' }}>
                <div className="pointer" style={{ pointerEvents: this.state.assigningBoxes.length === 0 ? '' : '' }}
                  onClick={() => {
                    if (this.state.assigningBoxes.length === 0) {
                      this.setState({
                        snackbarMessage: 'Please select OKAS Box.',
                        snackbarActive: true
                      })
                    } else {
                      this.openModal()
                    }
                  }
                  } >
                  <div className="buttonContent" style={{ backgroundColor: 'white', boxShadow: '0 4px 8px 0 rgba(0, 0, 0, 0.2)' }}>
                    {/* <Icon icon={iosPlusEmpty} size={40} style={{ color: "#F08100", backgroundColor: "none", }} /> */}
                    <IconButton sx={{
                      color: '#F08100',
                      fontSize: 40,
                      backgroundColor: 'transparent',
                      '&:hover': {
                        backgroundColor: 'transparent'
                      },
                      '&:focus': {
                        outline: 'none',
                        border: 'none',
                        backgroundColor: 'transparent'
                      }
                    }} aria-label="add">
                      <AddIcon sx={{ fontSize: 40 }} />
                    </IconButton>
                    <span style={{ color: '#888888', fontSize: '10px', fontWeight: '600' }}>ASSIGNEE DISTRIBUTOR</span>
                  </div>
                </div>
              </div> : null}
            </span>
          </div> : <div className='animated animated-duration-custom slideInDown pb-3 mt-2 flex-fill'>
            <SearchBar autoFocus
              value={this.state.searchValue}
              onChange={(e) => {
                this.setState({
                  searchValue: e
                }, () => {
                  this.sortingFunc('search', this.state.searchValue)
                })
              }
              }
              onRequestSearch={() => this.sortingFunc('search', this.state.searchValue)}
              resetSearch={(e) => {
                this.setState({
                  searchValue: e
                }, () => {
                  this.sortingFunc('search', '')
                })
              }}
            /></div>}
          <div className="si-lisst col-s12">
            {this.state.addAnotherSuccess}
            <table className="table">
              <thead className="tableHeaderColor" style={{ borderRadius: '10px 10px 0px 0px' }}>
                <th scope="col" style={{ width: '5%' }}>
                  <CheckboxMaterialUIWhite
                    changeHandler={this.assignBoxCheckHandler.bind(this, 'all')}
                    checkedStatus={this.checkStatusForAll('all') && this.state.assigningBoxes.length !== 0}
                  />
                </th>
                <th scope="col" style={{ width: '15%', verticalAlign: 'middle', fontSize:'12px' }}>Type
                  <i class={this.fetchIconType('okasBox_type')} onClick={(e) => { this.sortingFunc('okasBox_type') }}></i>
                </th>
                <th scope="col" style={{ width: '20%', verticalAlign: 'middle', fontSize:'12px' }}>Serial No
                  <i class={this.fetchIconType('okasBox_serialNo')} onClick={(e) => { this.sortingFunc('okasBox_serialNo') }}></i>
                </th>
                <th scope="col" style={{ width: '15%', verticalAlign: 'middle', fontSize:'12px' }}>Version
                  <i class={this.fetchIconType('okasBox_version')} onClick={(e) => { this.sortingFunc('okasBox_version') }}></i>
                </th>
              </thead>
              <tbody style={{ maxHeight: `${window.innerHeight - 280}px` }}>
                {this.obDatatable()}
              </tbody>
            </table>
          </div>
        </div>
        {this.ActivateAssignOBModel()}
      </React.Fragment>
    );
  }
}

const mapStateToProps = state => {
  return {
    redux: state,
  };
};


const mapDispatchToProps = dispatch => {
  return {
    searchBarActivate: (data) => dispatch({ type: ActionTypes.SEARCHBAR, data: data }),
  };
};


export default connect(mapStateToProps, mapDispatchToProps)(AssignOkasboxes);